<template>
    <div class="dk-open-video">
        <a href="#" class="dk-open-video__toggler" @click.prevent="showVideoModal">
            <slot></slot>
        </a>
    </div>
</template>

<script>
import DkVideoModal from '@v4/common/components/molecules/DkVideoModal.vue';
import { dkModalAware } from '@v4/common/components/mixins/modal';

export default {
    name: 'DkOpenVideo',
    // eslint-disable-next-line vue/no-unused-components
    components: { DkVideoModal },
    mixins: [dkModalAware],
    props: {
        provider: {
            type: String,
            default: '',
        },
        videoId: {
            type: String,
            default: '',
        },
        videoUrl: {
            type: String,
            default: '',
        },
        modalOpts: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        modalOptions() {
            return {
                name: `dk-open-video__modal-${this.videoId || this._uid}`,
                classes: ['dk-open-video__modal', `dk-open-video__modal-${this.provider || 'generic'}`],
                maxHeight: 650,
                maxWidth: 1200,
                height: '70%',
                width: '70%',
                clickToClose: true,
                ...this.modalOpts,
            };
        },
    },
    methods: {
        showVideoModal($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $event.cancelBubble = true;
            this.showModal(
                DkVideoModal,
                {
                    provider: this.provider,
                    videoId: this.videoId,
                    videoUrl: this.videoUrl,
                },
                this.modalOptions
            );
        },
    },
};
</script>
